// Copyright (c) 2026 Watch Tower Bible and Tract Society of Pennsylvania
// All Rights Reserved. Proprietary and confidential.
// Unauthorized copying, modification, or distribution is strictly prohibited.
import { S25B_CONFIG } from './s25b';
import { S45B_CONFIG } from './s45b';
import { S26_CONFIG } from './s26';
import { S44_CONFIG } from './s44';
import { S24_CONFIG } from './s24';

export const FORM_CONFIGS = {
  s25b: S25B_CONFIG,
  s45b: S45B_CONFIG,
  s26: S26_CONFIG,
  s44: S44_CONFIG,
  s24: S24_CONFIG,
};

export function getFormConfig(formType) {
  return FORM_CONFIGS[formType] || FORM_CONFIGS.s25b;
}

export function getFieldLabel(formType, fieldName) {
  const config = getFormConfig(formType);
  return config.fieldMap[fieldName]?.label || fieldName;
}

export function getFieldSection(formType, fieldName) {
  const config = getFormConfig(formType);
  return config.fieldMap[fieldName]?.section || null;
}

export function getSectionColors(formType) {
  const config = getFormConfig(formType);
  return config.sectionColors;
}

export { S25B_CONFIG } from './s25b';
export { S45B_CONFIG } from './s45b';
export { S26_CONFIG } from './s26';
export { S44_CONFIG } from './s44';
export { S24_CONFIG } from './s24';
